export const messages = {
  code: 200,
  data: {
    total: 4,
    rows: [
      { nickname: "mock", id: 25, content: "ようやっと作り終えたか", createDate: "2024-09-17", avatar: "https://qiheizhiya.oss-cn-shenzhen.aliyuncs.com/image/avatar6.jpg" },
      { nickname: "mock", id: 26, content: "頑張ったな", createDate: "2024-09-17", avatar: "https://qiheizhiya.oss-cn-shenzhen.aliyuncs.com/image/avatar4.jpg" },
      { nickname: "mock", id: 27, content: "不错哦", createDate: "2024-09-17", avatar: "https://qiheizhiya.oss-cn-shenzhen.aliyuncs.com/image/avatar8.jpg" },
      { nickname: "mock", id: 28, content: "good", createDate: "2024-09-17", avatar: "https://qiheizhiya.oss-cn-shenzhen.aliyuncs.com/image/avatar2.jpg" },
    ],
  },
}
